import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/lib/utils';

function Progress({
  className,
  value,
  shimmer = false,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  /** Overlay a light sweep across the fill to signal live streaming. */
  shimmer?: boolean;
}) {
  return (
    <ProgressPrimitive.Root
      data-slot='progress'
      className={cn(
        'bg-primary/20 relative h-2 w-full overflow-hidden rounded-full',
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot='progress-indicator'
        className='bg-primary relative h-full w-full flex-1 overflow-hidden transition-all'
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      >
        {shimmer && (
          <span
            className='animate-progress-shimmer pointer-events-none absolute inset-0'
            style={{
              background:
                'linear-gradient(90deg, transparent 20%, rgba(255,255,255,0.75) 50%, transparent 80%)',
              backgroundSize: '200% 100%',
            }}
          />
        )}
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  );
}

export { Progress };
